import { render, staticRenderFns } from "./PropTooltip.vue?vue&type=template&id=4accde50&"
import script from "./PropTooltip.vue?vue&type=script&lang=js&"
export * from "./PropTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports